import { useEffect, useContext, useState } from 'react';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import Modal from 'react-modal';
import classes from './MenuCardMobile.module.scss';
import { GeneralContext } from '../../../context/generalContext';
import MenuPhotoModal from '../MenuPhotoModal/MenuPhotoModal';
import closeIcon from '../../../images/icon-close.png';

Modal.setAppElement('#root');

export default function MenuCardMobile({
  isOpen,
  setIsOpen,
  item,
  choices,
  filteredItem,
  activeType,
  changeType,
  setModalPhotoActive,
  modalPhotoActive,
}) {
  const { activeLanguage, activeCity } = useContext(GeneralContext);

  // заморозить область за модальным если оно открыто
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
    } else {
      document.body.style.overflow = 'visible';
      document.body.style.position = '';
    }
  }, [isOpen]);

  useEffect(() => {
    const onScroll = () => {
      document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
    };
    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // -----для свайпа------:
  const [isFixed, setIsFixed] = useState(false);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const onTouchStart = e => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientY);
  };

  const onTouchMove = e => setTouchEnd(e.targetTouches[0].clientY);

  let distance;
  const onTouchEnd = () => {
    // мин расстояние которое признаем свайпом
    const minSwipeDistance = 2;
    if (!touchStart || !touchEnd) return;
    distance = -touchEnd + touchStart;
    const isUpSwipe = distance > minSwipeDistance;
    if (isUpSwipe) {
      moveUp();
    }
  };

  const moveUp = () => {
    console.log('move up');
    const block = document.getElementById('MenuCardMobile');
    const list = document.getElementById('MenuCardMobileContent');
    if (block.style.top !== '0px') {
      const oldHeight = Number(block.style.top.slice(0, -2));
      if (oldHeight - distance <= 0) {
        // проверяем насколько уже сдвинут блок
        block.style.top = `0px`;
        list.style.overflowY = 'scroll';
        setIsFixed(true);
      } else {
        block.style.top = `${oldHeight - distance}px`;
      }
    }
  };

  // ------

  const closeModal = () => {
    setIsOpen(false);
    setIsFixed(false);
  };

  return (
    <Modal
      htmlOpenClassName='ReactModal__Html--open'
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel='My dialog'
      className={isFixed ? classes.modalFixed : classes.modal}
      overlayClassName={classes.overlay}
      id='MenuCardMobile'
      style={{ content: { top: '30vh' } }}
      closeTimeoutMS={300}
    >
      <div className={classes.modalDiv} onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>
        <div className={classes.title}>{activeLanguage === 1 ? 'Состав блюда' : 'Ingredients'}</div>
        <div className={isFixed ? classes.closeIcon : classes.disabled} onClick={() => closeModal()}>
          <img src={closeIcon} alt='close icon' />
        </div>

        <div
          className={classes.cardModalMob}
          id='MenuCardMobileContent'
          style={{ maxHeight: `${window.innerHeight - 89}px`, overflowY: 'hidden' }}
        >
          <div className={classes.cardModalTitle}>{activeLanguage === 1 ? item.name : item.name_en || item.name}</div>

          {choices.length >= 2 && choices[0]?.name.length >= 2 ? (
            <>
              {filteredItem?.img && (
                <LazyLoadComponent>
                  <div
                    className={classes.cardModalImg}
                    style={{ backgroundImage: `url(${filteredItem?.img})` }}
                    onClick={() => setModalPhotoActive(true)}
                  />
                </LazyLoadComponent>
              )}
              <div className={classes.cardModalTypeDiv}>
                <div className={classes.cardModalTypes}>
                  {choices.map((choice, index) => (
                    <button
                      className={` ${classes.cardModalType} 
                          ${
                            activeLanguage === 1
                              ? activeType === item.info.filter(el => el.type === choice.name)[0]?.type
                                ? `${classes.cardModalTypeActive}`
                                : ''
                              : activeType === item.info.filter(el => el.type_en === choice.name_en)[0]?.type_en
                                ? `${classes.cardModalTypeActive}`
                                : ''
                          }
                        `}
                      onClick={
                        activeLanguage === 1
                          ? () => changeType(item.info.filter(el => el.type === choice.name)[0]?.type)
                          : () => changeType(item.info.filter(el => el.type_en === choice.name_en)[0]?.type_en)
                      }
                      key={index}
                    >
                      {activeLanguage === 1
                        ? item.info.filter(el => el.type === choice.name)[0]?.type
                        : item.info.filter(el => el.type_en === choice.name_en)[0]?.type_en}
                    </button>
                  ))}
                </div>
              </div>
              <p
                className={classes.cardModalText}
                dangerouslySetInnerHTML={{
                  __html:
                    activeLanguage === 1
                      ? filteredItem?.text || filteredItem?.description_ru
                      : filteredItem?.text_en ||
                        filteredItem?.description_en ||
                        filteredItem?.text ||
                        filteredItem?.description_ru,
                }}
              />
              <div className={classes.cardModalPriceWeight}>
                {activeCity !== 0 && (
                  <p
                    className={classes.cardModalPrice}
                    dangerouslySetInnerHTML={{
                      __html: `${
                        activeLanguage === 1
                          ? choices.filter(choice => choice.name === activeType)[0]?.price
                          : choices.filter(choice => choice.name_en === activeType)[0]?.price
                      }&nbsp;${activeCity === 6 ? 'uzs' : '&#8381;'}`,
                    }}
                  />
                )}
                {filteredItem?.weight && (
                  <p className={classes.cardModalWeight}>
                    {filteredItem?.weight}
                    {activeLanguage === 1 ? ' г' : ' g'}
                  </p>
                )}
              </div>
              {filteredItem?.calories && (
                <p className={classes.cardModalTextInfo}>
                  {activeLanguage === 1 ? 'КБЖУ ' : 'CPFC '}
                  {filteredItem?.calories}
                  &nbsp;<span className={classes.cardModalSlash}>/</span> {filteredItem?.proteins}
                  &nbsp;<span className={classes.cardModalSlash}>/</span> {filteredItem?.fats}
                  &nbsp;<span className={classes.cardModalSlash}>/</span> {filteredItem?.carbohydrates}
                </p>
              )}
            </>
          ) : (
            <>
              {item.img && (
                <LazyLoadComponent>
                  <div
                    className={classes.cardModalImg}
                    style={{ backgroundImage: `url(${item.img})` }}
                    onClick={() => setModalPhotoActive(true)}
                  />
                </LazyLoadComponent>
              )}
              <p
                className={classes.cardModalText}
                dangerouslySetInnerHTML={{
                  __html:
                    activeLanguage === 1
                      ? item.info[0]?.text || item.description_ru
                      : item.info[0]?.text_en || item.description_en || item.info[0]?.text || item.description_ru,
                }}
              />
              <div className={classes.cardModalPriceWeight}>
                {activeCity !== 0 && (
                  <p
                    className={classes.cardModalPrice}
                    dangerouslySetInnerHTML={{
                      __html: `${choices[0]?.price}&nbsp;${activeCity === 6 ? 'uzs' : '&#8381;'}`,
                    }}
                  />
                )}
                {item.info[0]?.weight && (
                  <p className={classes.cardModalTextInfo}>
                    {item.info[0]?.weight}
                    {activeLanguage === 1 ? ' г' : ' g'}
                  </p>
                )}
              </div>
              {item.info[0]?.calories && (
                <p className={classes.cardModalTextInfo}>
                  {activeLanguage === 1 ? 'КБЖУ ' : 'CPFC '}
                  {item.info[0]?.calories}
                  &nbsp;<span className={classes.cardModalSlash}>/</span> {item.info[0]?.proteins}
                  &nbsp;<span className={classes.cardModalSlash}>/</span> {item.info[0]?.fats}
                  &nbsp;<span className={classes.cardModalSlash}>/</span> {item.info[0]?.carbohydrates}
                </p>
              )}
            </>
          )}
          <div className={classes.cardModalBtn} onClick={() => closeModal()}>
            <p>{activeLanguage === 1 ? 'Вернуться к меню' : 'Back to menu'}</p>
          </div>
        </div>

        <MenuPhotoModal
          modalPhotoActive={modalPhotoActive}
          setModalPhotoActive={setModalPhotoActive}
          item={item}
          image={filteredItem?.img || item.img}
        />
      </div>
    </Modal>
  );
}
